import React from 'react'
import {motion} from 'framer-motion'
import {AppWrap, MotionWrap} from '../../wrapper'
import './FeaturedProjects.scss'

const FeaturedProjects = () => {
  const projects = [
    {
      id: 1,
      title: 'Government Service Platform Redesign',
      description: 'Redesigned a government digital platform to improve citizen engagement and service delivery.',
      category: 'Technology',
      icon: '🏛️'
    },
    {
      id: 2,
      title: 'SME Business Expansion into West Africa',
      description: 'Strategic market entry support for international company expanding across West African markets.',
      category: 'Business Expansion',
      icon: '🌍'
    },
    {
      id: 3,
      title: 'E-Learning Platform for Institutions',
      description: 'Comprehensive learning management system design and implementation for educational institutions.',
      category: 'Education & Training',
      icon: '📚'
    },
    {
      id: 4,
      title: 'Mobile App for Community Engagement',
      description: 'User-friendly mobile application connecting communities and facilitating local engagement.',
      category: 'Technology',
      icon: '📱'
    },
    {
      id: 5,
      title: 'Brand Development for Emerging Businesses',
      description: 'Complete branding and website development for startups and growing businesses.',
      category: 'Marketing & Branding',
      icon: '🎨'
    }
  ]

  return (
    <div className='app__featured-projects-wrapper-upper'>
      <motion.h2 
        whileInView={{opacity: [0, 1]}}
        transition={{duration: 0.6}}
        className='head-text'
      >
        Featured <span>Projects</span> & <span>Case Studies</span>
      </motion.h2>
      
      <div className='app__featured-projects-wrapper'>
        <div className='app__featured-projects-container'>
          {projects.map((project, index) => (
            <motion.div
              whileInView={{opacity: [0, 1], y: [50, 0]}}
              transition={{duration: 0.5, delay: index * 0.1}}
              className='app__featured-project-item app__flex'
              key={project.id}
            >
              <div className='app__featured-project-icon'>
                <span>{project.icon}</span>
              </div>
              <div className='app__featured-project-content'>
                <div className='app__featured-project-category'>
                  <span className='p-text'>{project.category}</span>
                </div>
                <h4 className='bold-text'>{project.title}</h4>
                <p className='p-text'>{project.description}</p>
              </div>
            </motion.div>
          ))}
        </div>

        <motion.div 
          whileInView={{opacity: [0, 1]}}
          transition={{duration: 0.7, delay: 0.6}}
          className='app__featured-projects-cta'
        >
          <button className='app__featured-projects-btn'>
            <span>View All Projects</span>
          </button>
        </motion.div>
      </div>
    </div>
  )
}

export default AppWrap(
  MotionWrap(FeaturedProjects, 'app__featured-projects'),
  'featured-projects',
  'app__primarybg'
)